export const profileContainer = 10;
export const sideBarIndex = 7;
export const content = 0;
export const tagSuggestions = 1;
export const tabulators = 1;
export const header = 2;
